// 
import { isRoutingAnchor } from '../lib/urlAndLink';
import { resolveExecute } from './partialUpdate';
import { getParentPartialUpdateContainer } from './partialUpdateUtils';
import {
  getClosestPartialUpdateSettings,
  getElementPartialUpdateSettings,
} from './PartialUpdateSettings';

/**
  Automaticky nabinduje partial update na všechny odkazy
  Pokud odkaz odpavídá kritériím, že se jedná o odkay webu a je uvnitř partial updatu
*/
export default (settings) => {
  document.addEventListener('click', (e) => {
    if (!e.defaultPrevented) {
      const closestHrefElement = e.target.closest('a');
      if (closestHrefElement) {
        if (
          isRoutingAnchor(closestHrefElement) &&
          getParentPartialUpdateContainer(closestHrefElement) != null
        ) {
          e.preventDefault();
          resolveExecute(closestHrefElement, {
            ...settings,
            ...getClosestPartialUpdateSettings(closestHrefElement, ['target', 'requestTarget', 'url']),
            ...getElementPartialUpdateSettings(closestHrefElement),
          });
        }
      }
    }
  });
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/partialUpdate/connectLinksListeners.js